import React from 'react';

import { BackButton } from '../../../../../../components/Clickables/Controls/BackButton/BackButton';
import { Heading } from '../../../../../../components/Heading/Heading';
import {
  ALL_POI_TOGGLEABLE_GROUPS,
  POINTS_OF_INTEREST,
} from '../../../../../../components/Maps/constants/mapLayers/pointsOfInterest';
import { Text } from '../../../../../../components/Text/Text';
import { ToggleSwitch } from '../../../../../../components/ToggleSwitch/ToggleSwitch';
import { useMapLayers } from '../../../../../../contexts/MapLayersContext';
import { trackEvent } from '../../../../../../helpers/analytics/trackEvent';
import { useExplore } from '../../../../context/ExploreContext';
import { MapDrawerLayout } from '../../MapDrawerLayout';
import { MapLayerSwitch } from '../MapLayersView/components/MapLayerSwitch';

export const POISettingsView = () => {
  const { saveParamsInUrl } = useExplore();
  const {
    layers: {
      pointsOfInterest: { isWholeLayerVisible, toggleableGroups },
    },
    toggleLayer,
    toggleToggleableGroup,
    setToggleableGroups,
  } = useMapLayers();

  const current = toggleableGroups.length;
  const max = ALL_POI_TOGGLEABLE_GROUPS.length;

  const handleOnClose = (): void => {
    if ((current === 0 && isWholeLayerVisible) || (current !== 0 && !isWholeLayerVisible)) {
      toggleLayer('pointsOfInterest');
    }
    saveParamsInUrl({
      drawerView: 'map-layers',
    });
  };

  const handleShowAll = (): void => {
    if (current === max) {
      setToggleableGroups('pointsOfInterest', []);
    } else {
      setToggleableGroups('pointsOfInterest', ALL_POI_TOGGLEABLE_GROUPS);
    }
  };

  return (
    <MapDrawerLayout
      withCloseButton={false}
      headerContent={
        <div>
          <BackButton variant="controlLakeFogBg" onClick={handleOnClose} />
          <Heading as="h1" variant="sm" className="mb-6">
            Points of interest
          </Heading>
        </div>
      }
    >
      <Text variant="sm" className="mt-1 mb-0">
        Valuable local information for your fishing trips: boat ramps, tackle shops, marinas, and
        more. Provided by our partner, Recreational Boating and Fishing Foundation.
      </Text>
      <div className="mt-4 mb-3 flex items-center justify-between">
        <Text variant="sm" className="mb-0 font-semibold">
          Showing {current} out of {max}
        </Text>
        <div className="flex items-center">
          <Text variant="sm" className="mr-2 mb-0 font-semibold">
            Show all
          </Text>
          <ToggleSwitch isActive={current === max} onClick={handleShowAll} />
        </div>
      </div>
      {Object.entries(POINTS_OF_INTEREST)
        .sort(([, poiA], [, poiB]) => poiA.order - poiB.order)
        .map(([poiName, poi]) => (
          <MapLayerSwitch
            key={`layer-switch-${poiName}`}
            title={poi.name}
            icon={poi.icon}
            isActive={toggleableGroups.includes(poi.toggleableGroup)}
            onClick={() => {
              toggleToggleableGroup('pointsOfInterest', poi.toggleableGroup);
              void trackEvent({
                name: 'mykiss_explore_sub_layer_toggled',
                properties: {
                  layer_type: 'points_of_interest',
                  state: toggleableGroups.includes(poi.toggleableGroup),
                },
              });
            }}
          />
        ))}
    </MapDrawerLayout>
  );
};
